import React, { useState, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import Swal from "sweetalert2";

function EmpresasCreate() {
  const { user } = useContext(AuthContext);
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS || (process.env.REACT_APP_URL_AREAS || "").replace("areas", "empresas");
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [name, setName] = useState("");
  const [razon_social, setRazonSocial] = useState("NA");
  const [RFC, setRFC] = useState("NA");
  const [validaBoton, setValidaBoton] = useState(true);

  const saveEmpresa = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    try {
      await axios
        .post(
          URL_EMPRESAS,
          {
            name,
            razon_social,
            RFC,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          axios.post(
            URL_LOGS,
            {
              tipo: "Crear Empresa",
              detalle: name,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
          Swal.fire("Good job!", "Creado con exito", "success");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response?.data?.message || ""}`,
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      console.log(error);
      setValidaBoton(true);
    }
  };

  return (
    <div className="card container">
      <h3 align="center">Nueva Empresa</h3>
      <Form onSubmit={saveEmpresa}>
        <FormGroup>
          <Label>Nombre</Label>
          <Input
            type="text"
            placeholder="Nombre"
            value={name}
            required
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          <Label>Razon Social</Label>
          <Input
            type="text"
            placeholder="Razon Social"
            value={razon_social}
            required
            onChange={(e) => {
              setRazonSocial(e.target.value);
            }}
          />
          <Label>RFC</Label>
          <Input
            type="text"
            placeholder="RFC"
            value={RFC}
            required
            onChange={(e) => {
              setRFC(e.target.value);
            }}
          />
        </FormGroup>
        <br />
        {validaBoton ? (
          <Button type="submit" className="btn btn-success">
            Guardar
          </Button>
        ) : (
          <Button type="submit" className="btn btn-success" disabled>
            Guardar
          </Button>
        )}
      </Form>
    </div>
  );
}

export default EmpresasCreate;
